import { useState } from "react";
import BookCeleb from "./BookCeleb.jsx";

function PickCeleb() {
  const [cars] = useState([
    {
      air: "Private Celebrity type tour",
      img: require("../images/faq/hr3.jpg"), // Ensure proper resolution
      name: "Dj Khaled",
      price: "500",
      fuel: "2 hr",
    },
    {
      air: "Private Celebrity type tour",
      img: require("../images/faq/hr4.jpg"), // Ensure proper resolution
      name: "James Harden",
      price: "500",
      fuel: "2 hr",
    },
    {
      air: "Private Celebrity type tour",
      img: require("../images/faq/hr7.jpg"), // Ensure proper resolution
      name: "Ja Rule",
      price: "500",
      fuel: "2 hr",
    },
    {
      air: "Private Celebrity type tour",
      img: require("../images/faq/hr6.jpg"), // Ensure proper resolution
      name: "Lil Durk",
      price: "500",
      fuel: "2 hr",
    },
    {
      air: "Private Celebrity type tour",
      img: require("../images/faq/hr5.jpg"), // Ensure proper resolution
      name: "Polo G",
      price: "500",
      fuel: "2 hr",
    },
  ]);

  const [selectedCar, setSelectedCar] = useState(null); // State for selected car
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (car) => {
    setSelectedCar(car.name); // Set selected car name
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCar(null); // Clear selected car name when modal closes
  };

  const scrollToCelebGallery = () => {
    const celebGalleryElement = document.getElementById("celebzi");
    if (celebGalleryElement) {
      celebGalleryElement.scrollIntoView({ behavior: "smooth" });
    }
  };



  return (
    <section id="pick-section" className="pick-section" style={{ marginTop: "-235px", marginBottom: "70px" }}>
      <div className="container">
        <div className="pick-container__title">
          <h2>Celebrity ATV Tours</h2>
          <p>We offer a range of celebrity ATV tour packages so our clients can have maximum fun.</p>

          <p>
        <a
          href="#celebzi" // Fallback for non-JavaScript environments
          onClick={(e) => {
            e.preventDefault(); // Prevent default anchor behavior
            scrollToCelebGallery(); // Smooth scroll to the element
          }}
          style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
        >
          View Celebrity gallery
        </a>
      </p>

        </div>


        <div className="row">
          {cars.map((car, index) => (
            <div key={index} className="col-12 col-md-6" style={{ position: "relative", height: "350px", marginBottom: "85px" }}>
              <div
                className="models-div__box"
                style={{
                  backgroundColor: "black",
                  borderRadius: "8px",
                  transition: "transform 0.3s ease",
                  boxShadow: "0px 0px 5px 7px #b8860b, 0px 3px 3px 4px #b8860b",
                  overflow: "hidden",
                  cursor: "pointer",
                  width: "100%",
                }}
                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
              >
                <div className="models-div__box__img" style={{ position: "relative" }}>
                  <img
                    src={car.img}
                    alt="car_img"
                    style={{
                      height: "250px",
                      width: "100%",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                      paddingLeft: "55px",
                      paddingRight: "55px",
                      background: "linear-gradient(135deg, #f7e9a0, #ffcc00, #d4af37, #B8860B)",
                      
                    }}
                  />
                  <div
                    className="models-div__box__img-overlay"
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      backgroundColor: "rgba(0, 0, 0, 0.85)",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    {car.name}
                  </div>
                </div>
                <div className="models-div__box__descr" style={{ padding: "15px" }}>
                  <div className="models-div__box__descr__price" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <h4 style={{ margin: "5px 10px 5px 0", color: "white", fontSize: "24px" }}>${car.price}</h4>
                    <p style={{ margin: "0", fontSize: "14px", color: "silver" }}>for {car.fuel}</p>
                  </div>
                  <div className="models-div__box__descr__details">
                    <span style={{ fontSize: "12px", margin: "2px", color: "white" }}>&#x2022; {car.air}</span>
                  </div>
                  <button
                    className="models-div__box__descr__btn"
                    style={{
                      height: "40px",
                      width: "100%",
                      background: "linear-gradient(135deg, #f7e9a0, #ffcc00, #d4af37, #B8860B)",
                      backgroundSize: "200% 200%",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      marginTop: "10px",
                      fontSize: "15px",
                      color: "white",
                    }}
                    onClick={() => openModal(car)} // Pass car name on click
                  >
                    Reserve Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Pass selectedCar to BookCeleb */}
      <BookCeleb carName={selectedCar} isModalOpen={isModalOpen} closeModal={closeModal} />
    </section>
  );
}

export default PickCeleb;

